import { hostedFieldsClassStruture, hostedFieldsRequiredAndInvalid } from './card-option-config';
export const validateHostedFields = (err, clientInstance) => {
    if (err.code === 'HOSTED_FIELDS_FIELDS_EMPTY') {
        const highlightedItems = document.querySelectorAll('.invalid-field');
        highlightedItems.forEach((userItem) => {
            userItem.classList.remove('invalid-field');
            userItem.classList.add('valid-field');
        });
        const FieldItem = document.querySelectorAll('.tc-hosted-field');
        FieldItem.forEach((userItem) => {
            userItem.classList.add('tc-hosted-field-error');
        });
        const yearFieldItem = document.querySelectorAll('.tc-hosted-year-field');
        yearFieldItem.forEach((yearItem) => {
            yearItem.classList.add('tc-hosted-field-error');
        });
        const monthFieldItem = document.querySelectorAll('.tc-hosted-month-field');
        monthFieldItem.forEach((monthItem) => {
            monthItem.classList.add('tc-hosted-field-error');
        });
        const cvvFieldItem = document.querySelectorAll('.tc-hosted-field-cvv');
        cvvFieldItem.forEach((cvvItem) => {
            cvvItem.classList.add('tc-hosted-field-error');
        });
        clientInstance.on('focus', (event) => {
            if (event.emittedBy === 'number') {
                const ccNumbererror = document.querySelector('#cc-number');
                ccNumbererror.nextElementSibling.classList.add('invalid-field');
                ccNumbererror.nextElementSibling.classList.remove('valid-field');
                const numberUnderLine = document.querySelector('#cc-number');
                numberUnderLine.classList.add('tc-hosted-field');
                numberUnderLine.classList.remove('tc-hosted-field-error');
            }
            if (event.emittedBy === 'cvv') {
                const ccvError = document.querySelector('#cc-cvv');
                ccvError.nextElementSibling.nextElementSibling.classList.add('invalid-field');
                ccvError.nextElementSibling.nextElementSibling.classList.remove('valid-field');
                const ccvUnderLine = document.querySelector('#cc-cvv');
                ccvUnderLine.classList.add('tc-hosted-field');
                ccvUnderLine.classList.remove('tc-hosted-field-error');
            }
            if (event.emittedBy === 'expirationMonth') {
                const expMonthError = document.querySelector('#alert-cc-expiration-month');
                expMonthError.classList.add('invalid-field');
                expMonthError.removeChild(expMonthError.firstChild)
                expMonthError.classList.remove('valid-field');
                const expMonthUnderLine = document.querySelector('#cc-expiration-month');
                expMonthUnderLine.classList.add('tc-hosted-month-field');
                expMonthUnderLine.classList.remove('tc-hosted-field-error');
            }
            if (event.emittedBy === 'expirationYear') {
                const expYearError = document.querySelector('#alert-cc-expiration-year');
                expYearError.classList.add('invalid-field');
                expYearError.removeChild(expYearError.firstChild)
                expYearError.classList.remove('valid-field');
                const expYearUnderLine = document.querySelector('#cc-expiration-year');
                expYearUnderLine.classList.add('tc-hosted-year-field');
                expYearUnderLine.classList.remove('tc-hosted-field-error');
            }
        });
    }
    if (err.code === 'HOSTED_FIELDS_FIELDS_INVALID') {
        const getInvalidMsg = document.querySelector('.invalid-cc-error');
        getInvalidMsg.classList.remove('hide-invalid-alert');
        getInvalidMsg.classList.add('show-invalid-alert');
    }
}

export const validateHostedFieldsAble = (err, clientInstance) => {
    if (err.code === 'HOSTED_FIELDS_FIELDS_EMPTY') {
        const stateValue = clientInstance.getState();
        Object.keys(stateValue.fields).forEach((field) => {
            const selectorValue = hostedFieldsClassStruture[field];
            const highlightedEmptyItem = document.querySelector(`.${hostedFieldsRequiredAndInvalid[field].required}`);
            if (highlightedEmptyItem !== null) {
                highlightedEmptyItem.classList.remove(hostedFieldsRequiredAndInvalid[field].required);
                highlightedEmptyItem.classList.add('valid-field');
            }
            const highlightedInvalidItem = document.querySelector(`#${hostedFieldsRequiredAndInvalid[field].invalid}`);
            if (highlightedInvalidItem !== null) {
                highlightedInvalidItem.classList.remove('show-invalid-message');
                highlightedInvalidItem.classList.add(hostedFieldsRequiredAndInvalid[field].invalid);
            }
            const FieldItem = document.querySelector(`.${selectorValue.class}`);
            FieldItem.classList.add('tc-hosted-field-error');
            clientInstance.setMessage({
                field,
                message: hostedFieldsRequiredAndInvalid[field].requiredMsg
            });
        })
        clientInstance.focus('number');
        clientInstance.on('notEmpty', (event) => {
            if (['number', 'cvv'].includes(event.emittedBy)) {
                const ccvError = document.querySelector(`#cc-${event.emittedBy}`);
                ccvError.nextElementSibling.classList.add(`invalid-field-cc-${event.emittedBy}`);
                ccvError.nextElementSibling.classList.remove('valid-field');
                const ccvUnderLine = document.querySelector(`#cc-${event.emittedBy}`);
                ccvUnderLine.classList.add('tc-hosted-field');
                ccvUnderLine.classList.remove('tc-hosted-field-error');
            }
            if (['expirationMonth', 'expirationYear'].includes(event.emittedBy)) {
                const fieldValue = event.emittedBy === 'expirationMonth' ? 'month' : 'year'
                const expMonthError = document.querySelector('#invalid-field-month-year');
                expMonthError.classList.add('invalid-field-month-year');
                expMonthError.classList.remove('valid-field');
                const expMonthUnderLine = document.querySelector(`#cc-expiration-${fieldValue}`);
                expMonthUnderLine.classList.add(`tc-hosted-${fieldValue}-field`);
                expMonthUnderLine.classList.remove('tc-hosted-field-error');
            }
            clientInstance.setMessage({
                field: event.emittedBy,
                message: ''
            });
        });
    }
    if (err.code === 'HOSTED_FIELDS_FIELDS_INVALID') {
        const invalidKeys = err.details.invalidFieldKeys;
        invalidKeys.forEach((invalidKey) => {
            const selectorValue = hostedFieldsClassStruture[invalidKey];
            const invalidField = document.querySelector(`.${hostedFieldsRequiredAndInvalid[invalidKey].invalid}`);
            if (invalidField !== null) {
                invalidField.classList.remove(hostedFieldsRequiredAndInvalid[invalidKey].invalid);
                invalidField.classList.add('show-invalid-message');
            }
            const emptyField = document.querySelector(`#${hostedFieldsRequiredAndInvalid[invalidKey].required}`);
            if (emptyField !== null) {
                emptyField.classList.remove('valid-field');
                emptyField.classList.add(hostedFieldsRequiredAndInvalid[invalidKey].required);
            }
            const FieldItem = document.querySelector(`.${selectorValue.class}`);
            FieldItem.classList.add('tc-hosted-field-error');
            clientInstance.setMessage({
                field: invalidKey,
                message: hostedFieldsRequiredAndInvalid[invalidKey].invalidMsg
            });
        });
        clientInstance.focus(invalidKeys[0]);
        clientInstance.on('blur', (event) => {
            if (['number', 'cvv'].includes(event.emittedBy)) {
                const ccNumbererror = document.querySelector(`#cc-${event.emittedBy}`);
                ccNumbererror.nextElementSibling.
                    nextElementSibling.classList.add(`invalid-entry-field-cc-${event.emittedBy}`);
                ccNumbererror.nextElementSibling.nextElementSibling.classList.remove('show-invalid-message');
                const numberUnderLine = document.querySelector(`#cc-${event.emittedBy}`);
                numberUnderLine.classList.add('tc-hosted-field');
                numberUnderLine.classList.remove('tc-hosted-field-error');
            }
            if (['expirationMonth', 'expirationYear'].includes(event.emittedBy)) {
                const fieldValue = event.emittedBy === 'expirationMonth' ? 'month' : 'year';
                const expMonthError = document.querySelector('#invalid-field-month-year');
                expMonthError.nextElementSibling.classList.add('invalid-entry-field-month-year');
                expMonthError.nextElementSibling.classList.remove('show-invalid-message');
                const expMonthUnderLine = document.querySelector(`#cc-expiration-${fieldValue}`);
                expMonthUnderLine.classList.add(`tc-hosted-${fieldValue}-field`);
                expMonthUnderLine.classList.remove('tc-hosted-field-error');
            }
            clientInstance.setMessage({
                field: event.emittedBy,
                message: ''
            });
        });
    }
}
